import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a71ad52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "league-index" }
const _hoisted_2 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal league-index-carousel"
}
const _hoisted_3 = { class: "el-carousel__container" }
const _hoisted_4 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_5 = { class: "fd-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("以下品牌正在招募 拎包入住代理商/社区分销商")
const _hoisted_7 = { class: "league-index-content" }
const _hoisted_8 = { class: "league-index-search" }
const _hoisted_9 = { class: "league-index-search-ss" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 标签 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "league-index-search-ss-des" }, "可多选", -1))
const _hoisted_12 = { class: "league-index-list" }
const _hoisted_13 = { class: "league-index-list-banner" }
const _hoisted_14 = {
  key: 0,
  class: "league-index-list-banner-status status3"
}
const _hoisted_15 = { class: "league-index-list-banner-label" }
const _hoisted_16 = {
  key: 1,
  class: "league-index-list-banner-status status4"
}
const _hoisted_17 = { class: "league-index-list-banner-label" }
const _hoisted_18 = {
  key: 2,
  class: "league-index-list-banner-status status5"
}
const _hoisted_19 = { class: "league-index-list-banner-label" }
const _hoisted_20 = {
  key: 3,
  class: "league-index-list-banner-status status6"
}
const _hoisted_21 = { class: "league-index-list-banner-label" }
const _hoisted_22 = { class: "league-index-list-info" }
const _hoisted_23 = { class: "league-index-list-line" }
const _hoisted_24 = { class: "league-index-list-lt" }
const _hoisted_25 = { class: "league-index-list-lt-name" }
const _hoisted_26 = { class: "league-index-list-rt" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"10px 10px"} }, " ", -1))
const _hoisted_28 = { class: "league-index-list-label" }
const _hoisted_29 = { class: "league-index-list-line" }
const _hoisted_30 = { class: "league-index-list-lt" }
const _hoisted_31 = { class: "league-index-list-label" }
const _hoisted_32 = { class: "league-index-list-rt" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("报名")
const _hoisted_34 = { class: "load-more" }
const _hoisted_35 = { class: "dialog-box" }
const _hoisted_36 = { class: "dialog-box-header" }
const _hoisted_37 = { class: "dialog-box-header-lt" }
const _hoisted_38 = { class: "dialog-box-header-rt" }
const _hoisted_39 = { class: "dialog-box-header-logo" }
const _hoisted_40 = { href: "bindData.activity.website" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = /*#__PURE__*/_createTextVNode("加入品牌意向 ")
const _hoisted_47 = {
  class: "join-dialog",
  id: "join-dialog",
  style: {"margin-top":"-40.1px","margin-left":"1126.75px"}
}
const _hoisted_48 = {
  class: "dialog-box",
  style: {"width":"380px","height":"430px","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode("会员报名")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("非会员报名")
const _hoisted_51 = ["src"]

import store from "@/store/index";
import { reactive, ref } from "vue";
import Bottom from "../components/bottom.vue";
import { ArrowDownBold, HelpFilled, Plus } from '@element-plus/icons-vue'
import router from "@/router/index";
import { Search } from '@element-plus/icons-vue'
import type { UploadFile, ElUploadProgressEvent, ElFile } from 'element-plus/es/components/upload/src/upload.type'
import JoinActivityVo from '@/beans/joinActivityVo';

interface TagVo {
  id: string;
  name: string;
}

interface ActivityVo {
  id: string;
  name: string;
  status: number;
  type: number;
  statusName: string;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  province: string;
  city: string;
  area: string;
  address: string;
  contact: string;
  mobile: string;
  lessonName: string;
  startTimeString: string;
  endTimeDateString: string;
  remainApplyNumber: number;
  request: string;
  isChoose: boolean;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activityTagSearch = ref(['全部'])
const loading = ref(false);
const remainCount = ref(0)
const detailDialogVisible = ref(false);
const applyListDialogVisible = ref(false);
const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const backtopVisible = ref(false)


const allTag: TagVo = {
  id: "all",
  name: "全部",
}

const bindData = reactive({
  isShowDefaultImage: true,
  defaultImage: "",
  images: [],
  activity: {
    id: '',
    name: '',
    status: 1,
    type: '',
    statusName: '',
    roomNumberName: '',
    deliveryDateString: '',
    decorateTypeName: '',
    thumbnailUrl: '',
    projectName: '',
    companyName: '',
    province: '',
    city: '',
    area: '',
    address: '',
    contact: '',
    mobile: '',
    lessonName: '',
    startTimeString: '',
    endTimeDateString: '',
    remainApplyNumber: 0
  },
  activityJoinList: new Array<JoinActivityVo>(),
  activityTagList: new Array<TagVo>(),
  activityPageParams: {
    curPage: 1,
    pageSize: 9,
    filtrate: {
      type: 7,
      activityTagIds: "",
      keyword: "",
    },
  },
  activityPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
});

const advertisingImageEvent = () => {
  store.dispatch("frontIndexModule/listAdvertisingImage", { type: 4 }).then(
    (data) => {
      console.log(data.result);
      bindData.images = data.result;
      if (data.result.length > 0) {
        bindData.defaultImage = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

advertisingImageEvent();

const loadTags = function () {
  var pageParams = {
    curPage: 1,
    pageSize: 20,
    filtrate: {
      isLast: 'Y',
      keyword: '',
    },
  };
  store.dispatch('frontLeagueModule/listBrandCategory', pageParams).then(
    (data) => {
      console.log(data);
      //成功
      bindData.activityTagList = data.result;
      bindData.activityTagList.unshift(allTag);
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

loadTags();

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  const activityTagArray = activityTagSearch.value.filter(tag => tag !== "全部");
  bindData.activityPageParams.filtrate.activityTagIds = bindData.activityTagList.filter(tag => activityTagArray.includes(tag.name)).map(tag => tag.id).join(",");
  store
    .dispatch(
      "frontLeagueModule/pageActivityList",
      bindData.activityPageParams
    )
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            // case 1:
            //   obj.statusName = "草稿";
            //   break;
            // case 2:
            //   obj.statusName = "待审核";
            //   break;
            case 3:
              obj.statusName = "即将开始";
              break;
            case 4:
              obj.statusName = "报名中";
              break;
            case 5:
              obj.statusName = "已开始";
              break;
            case 6:
              obj.statusName = "已结束";
              break;
            // case 7:
            //   obj.statusName = "已取消";
            //   break;
            default:
              obj.statusName = "--";
              break;
          }
        }
        if (isAppend) {
          data.result = bindData.activityPageResult.result.concat(data.result);
        }
        bindData.activityPageResult = data;
        remainCount.value = data.totalCount - bindData.activityPageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent(false);

const reloadSearchEvent = () => {
  bindData.activityPageParams.curPage = 1;
  bindData.activityPageParams.pageSize = 9;
  if (bindData.activityPageParams.filtrate.activityTagIds.length == 0) {
    if (activityTagSearch.value.length > 1) {
      activityTagSearch.value = activityTagSearch.value.filter(tag => tag !== "全部");
    }
  }
  else if (activityTagSearch.value.includes("全部")) {
    activityTagSearch.value = ["全部"];
  }
  searchEvent(false);
};

const loadPageDataEvent = () => {
  if (bindData.activityPageParams.curPage * bindData.activityPageParams.pageSize < bindData.activityPageResult.totalCount) {
    bindData.activityPageParams.curPage = bindData.activityPageParams.curPage + 1;
    searchEvent(true);
  }
};

const backToEvent = (event: MouseEvent) => {
  event.preventDefault();
  event.stopPropagation();
  applyListDialogVisible.value = true
}

// const joinDialogOpened = () => {
//   const myElement = document.querySelector("#join-dialog");
//   if (myElement != null) {
//     myElement.setAttribute("style", "top:20px;")
//   }
// }

const handleToDetail = (activity: any) => {
  bindData.activity = activity;
  detailDialogVisible.value = true
}

const handleToJoinList = (activity: any) => {
  const jsonAc: JoinActivityVo = {
    id: activity.id,
    uid: new Date().getTime(),
    name: activity.id,
    activityName: activity.name,
    url: activity.thumbnailUrl,
  }
  var joinIdList = bindData.activityJoinList.map(activityJoin => activityJoin.id);
  if (joinIdList.indexOf(activity.id) < 0) {
    bindData.activityJoinList.push(jsonAc);
  }

  detailDialogVisible.value = false
  applyListDialogVisible.value = true
  backtopVisible.value = true
}

const handleToTabel = () => {
  store.dispatch('frontLeagueModule/setActivityJoinList', bindData.activityJoinList)
    .then(
      (data) => {
        router.push('/frontDesk/leagueIndex/leagueTabel')
      },
      (error) => {
        console.log(error.msg);
      }
    );

}

const handleToMemberTabel = () => {
  //router.push('/frontDesk/leagueIndex/leagueMemberTabel')
  store.dispatch('frontLeagueModule/setActivityJoinList', bindData.activityJoinList)
    .then(
      (data) => {
        router.push('/frontDesk/leagueIndex/leagueMemberTabel')
      },
      (error) => {
        console.log(error.msg);
      }
    );
}

const handleRemove = (uploadFile: UploadFile) => {
  backtopVisible.value = bindData.activityJoinList.length > 0;
  //console.log(uploadFile, uploadFiles)
  for (var i = 0; i < bindData.activityJoinList.length; i++) {
    if (bindData.activityJoinList[i].id == uploadFile.name) {
      bindData.activityJoinList.splice(i, 1);
    }
  }
}

const handlePictureCardPreview = (uploadFile: UploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}

setTimeout(() => {
  bindData.isShowDefaultImage = false;
}, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_backtop = _resolveComponent("el-backtop")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_dialogdrag = _resolveDirective("dialogdrag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "league-index-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "league-index-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "league-index-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_container, { class: "league-index-divider" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_divider, { "content-position": "center" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_image, {
              class: "league-index-search-ss-icon",
              src: require('@/assets/fd/league/u8145.png')
            }, null, 8, ["src"]),
            _hoisted_10,
            _hoisted_11,
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).activityPageParams.filtrate.keyword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).activityPageParams.filtrate.keyword) = $event)),
              placeholder: "企业名称、品牌名称",
              class: "league-index-search-ss-ipt",
              size: "large",
              onKeyup: _withKeys(reloadSearchEvent, ["enter","native"])
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _unref(Search),
                  onClick: reloadSearchEvent
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue", "onKeyup"])
          ]),
          _createVNode(_component_el_checkbox_group, {
            class: "league-index-search-check",
            modelValue: activityTagSearch.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activityTagSearch).value = $event)),
            size: "large",
            onChange: reloadSearchEvent
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityTagList, (tag) => {
                return (_openBlock(), _createBlock(_component_el_checkbox, {
                  border: "",
                  key: tag.id,
                  label: tag.name
                }, null, 8, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityPageResult.result, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "league-index-list-item",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_image, {
                  class: "league-index-list-banner-img",
                  fit: "fill",
                  src: item.thumbnailUrl
                }, null, 8, ["src"]),
                (item.status == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.statusName || "--"), 1)
                    ]))
                  : (item.status == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.statusName || "--"), 1)
                      ]))
                    : (item.status == 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.statusName || "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(item.statusName || "--"), 1)
                        ]))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(item.brandName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createTextVNode(_toDisplayString(item.province) + "." + _toDisplayString(item.city) + "." + _toDisplayString(item.area) + " ", 1),
                    _hoisted_27,
                    _createVNode(_component_el_image, {
                      class: "league-index-list-rt-icon",
                      src: require('@/assets/fd/league/u7795.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", null, _toDisplayString(item.applyAuditPassNumber + item.applyWillAditNumber), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, _toDisplayString(item.brandDesc), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.joinCategoryNames), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "mini",
                      onClick: ($event: any) => (handleToDetail(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, loading.value]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_34, [
          (_unref(bindData).activityPageResult.result.length < _unref(bindData).activityPageResult.totalCount)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "load-more-button",
                type: "text",
                size: "large",
                onClick: loadPageDataEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDownBold))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(Bottom, { class: "league-index-bottom" }),
    _createVNode(_component_el_dialog, {
      title: "招募详情",
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detailDialogVisible).value = $event)),
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_el_image, {
                class: "",
                src: _unref(bindData).activity.thumbnailUrl
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_el_image, {
                  class: "dialog-box-header-banner",
                  src: _unref(bindData).activity.companyBrandLogo
                }, null, 8, ["src"])
              ]),
              _createVNode(_component_el_form, { "label-width": "100px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "品牌:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(bindData).activity.brandName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "声誉:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(bindData).activity.brandDesc), 1)
                    ]),
                    _: 1
                  }),
                  (_unref(bindData).activity.website != null)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "官网:"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_40, _toDisplayString(_unref(bindData).activity.website), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, { label: "企业全称:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(bindData).activity.companyName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "招募地区:" }, {
                    default: _withCtx(() => [
                      (_unref(bindData).activity.areaIds==null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(bindData).activity.province) + "，" + _toDisplayString(_unref(bindData).activity.city) + "，" + _toDisplayString(_unref(bindData).activity.area), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(bindData).activity.areaIds), 1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "招募类别:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(bindData).activity.joinCategoryNames), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_el_form, { "label-width": "100px" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "业务介绍：" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      innerHTML: _unref(bindData).activity.request
                    }, null, 8, _hoisted_43)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "商家条件：" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      innerHTML: _unref(bindData).activity.conditionDesc
                    }, null, 8, _hoisted_44)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "加盟流程：" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      innerHTML: _unref(bindData).activity.processDesc
                    }, null, 8, _hoisted_45)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_container, {
          slot: "footer",
          class: "dialog-footer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToJoinList(_unref(bindData).activity)))
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (backtopVisible.value)
      ? (_openBlock(), _createBlock(_component_el_backtop, {
          key: 2,
          right: 100,
          bottom: 200,
          "visibility-height": 5,
          onClick: backToEvent
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { size: 40 }, {
              default: _withCtx(() => [
                _createVNode(_unref(HelpFilled))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [
      _createVNode(_component_el_dialog, {
        title: "意向品牌加盟申请",
        modelValue: applyListDialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((applyListDialogVisible).value = $event)),
        width: "380px",
        "close-on-click-modal": false,
        modal: false,
        "lock-scroll": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "on-preview": handlePictureCardPreview,
              "on-remove": handleRemove,
              "file-list": _unref(bindData).activityJoinList
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["file-list"])
          ]),
          _createVNode(_component_el_container, {
            slot: "footer",
            class: "dialog-footer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "large",
                onClick: handleToMemberTabel
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "warning",
                size: "large",
                onClick: handleToTabel
              }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            "w-full": "",
            src: dialogImageUrl.value,
            alt: "查看大图"
          }, null, 8, _hoisted_51)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])), [
      [_directive_dialogdrag]
    ])
  ]))
}
}

})